<template>
  <div class="main-page-wrapper p0 overflow-hidden">
    <!-- header start -->
    <HeaderTwo />
    <!-- header end -->
    <!-- hero area start -->
    <div class="fancy-hero-five">
      <div class="bg-wrapper">
        <div class="container">
          <div class="text-center row">
            <div class="col-xl-9 m-auto">
              <h1 class="solution-main-heading heading flex align-items-center">
                <img alt=""
                     src="../../assets/images/logo/cross.svg"
                     width="50"
                     height="50"
                     class="heading-icon"/>
                Our Solutions
              </h1>
            </div>
          </div>
        </div>
      </div> <!-- /.bg-wrapper -->
    </div>
    <!-- hero area end -->

    <!-- details area start -->
    <div class="service-details-one pt-50 lg-pt-100">
      <div class="xl-container">
        <div class="row">

          <div class="fancy-feature-forty xl-container" id="product">
            <div class="container">

              <div v-for="solution in content.solutions" :key="solution._id" class="block-style-thirtyEight mb-200 md-mb-150">
                <div class="row align-items-center">
                  <div class="col-xl-5 col-lg-6" data-aos="fade-right">
                    <img :src="solution.icon.image?.asset.url"
                         :alt="solution.icon.alt"
                         class="solution-icon" />
                    <h2 class="solution-heading mt-10 mb-10">{{ solution.heading }}</h2>
                    <div class="solution-text mt-20">
                      <p>{{solution.excerpt}}</p>
                      <a :href="`/our-solutions/${solution.slug.current}`" class="solution-cta">
                        Learn more
                        <svg class="solution-cta-chevron" fill="#000000" width="800px" height="800px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.061 19.061 17.121 12l-7.06-7.061-2.122 2.122L12.879 12l-4.94 4.939z"/>
                        </svg>
                      </a>
                    </div>
                  </div>
                  <div class="col-xl-7 col-lg-5 col-md-8 ms-auto text-end d-flex align-items-center justify-content-center"
                      data-aos="fade-left">
                    <div class="solution-image-wrapper d-flex align-items-center justify-content-center mh-50 position-relative md-mt-70">
                      <img :key="solution.mainImage.image?.asset._id"
                           :alt="solution.mainImage?.image?.alt"
                           class="solution-image"
                           :src="urlFor(solution.mainImage?.image).width(400).height(400).fit('crop').auto('format').url()"
                           data-aos="fade-up"
                           data-aos-delay="300"/>
                      <img src="../../assets/images/logo/cross-white.svg"
                           alt=""
                           height="50"
                           width="50"
                           class="solution-cross-white"
                           data-aos="fade-up"
                           data-aos-delay="600">
                      <div class="solution-shape"
                           data-aos="fade-up"
                           data-aos-delay="300"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <client-feedback />
          <faq-accordion />
        </div>
      </div>
    </div>
    <!-- details area end -->

    <!-- footer start -->
    <FooterSeven :dark_bg="true" :dark_btn="true" />
    <!-- footer end -->
  </div>
</template>

<script>
import HeaderTwo from '@/components/common/Headers/HeaderTwo.vue';
import FooterSeven from '@/components/common/Footers/FooterSeven.vue';
import sanity from "../../../sanity.js";
import FaqAccordion from "@/components/content/faq-accordion.vue";
import ClientFeedback from '@/components/content/client-feedback.vue';
import {urlFor} from "@/mixins/sanityImageMixin";
import {useHead} from "@vueuse/head";
export default {
  name:'ServiceDetails',
  components: { FaqAccordion, ClientFeedback, HeaderTwo, FooterSeven },
  data() {
    return {
      loading: true,
      content: [],
    }
  },
  methods: {
    urlFor,
    async fetchData() {
      const query = `*[_type == "solutions"]{
        _id,
        title,
        slug,
        solutions[]->{
          title,
          slug,
          heading,
          icon {
            alt,
            image {
              asset->{
                metadata {
                  dimensions
                },
               url
              }
            },
          },
          excerpt,
          blockText,
          featureList[],
          ctaLine,
          mainImage {
            alt,
            image {
              asset->{
                metadata {
                  dimensions
                },
                url
              },
              hotspot,
              crop
            },
          }
        },
        seo {
          title,
          description,
          keywords,
          ogImage {
            asset->{
              url
            }
          }
        }
      }[0]`;
      this.error = this.home = null;
      this.loading = true;
      try {
        const content = await sanity.fetch(query);
        this.loading = false;
        this.content = content;
      } catch (error) {
        this.error = error;
      }
    },
  },
  async created() {
    await this.fetchData()
    useHead({
      title: `${this.content?.title} | Marshall Print`,
      meta: [
        { name: 'description', content: this.content?.seo?.description },
        { name: 'keywords', content: this.content?.seo?.keywords },
        // { property: 'og:title', content: this.content?.seo?.title },
        // { property: 'og:description', content: this.content?.seo?.description },
        // { property: 'og:image', content: this.content?.seo?.ogImage?.asset.url },
      ]
    })
  }
}
</script>

<style lang="scss" scoped>
.fancy-hero-five {
  background-color: var(--darkblue);

  .heading {
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .heading-icon {
    margin-right: 2rem;
    height: 3rem;
    width: 3rem;
    @media (max-width: 991px) {
      height: 2rem;
      margin-right: 1rem;
      width: 2rem;
    }
  }

  .solution-main-heading {
    font-size: 3rem;
    font-weight: 900;
    @media (max-width: 991px) {
      font-size: 2rem;
    }
  }
}
.fancy-feature-forty {
  margin: 2rem auto 0 auto;
  position: relative;
}
.block-style-thirtyEight .row {
  margin: 2rem auto;
}
.block-style-thirtyEight:nth-child(odd) .row {
  flex-direction: row-reverse;
  margin: 0;
}
.block-style-thirtyEight .row .solution-heading {
  color: var(--pink);
  font-size: 2.5rem;
  font-weight: 900;
  margin: 2rem 0;
  @media (max-width: 991px) {
    font-size: 1.75rem;
  }
}
.block-style-thirtyEight .row .solution-icon {
  height: auto;
  width: 3rem;
}
.block-style-thirtyEight .row .solution-text p {
  font-size: 1.3rem;
  line-height: 1.5;
}
.block-style-thirtyEight .row .solution-cta {
  display: flex;
  align-items: center;
  font-weight: bold;
  margin: 2rem 0 0 0;
  padding: 0;
}
.block-style-thirtyEight .row .solution-cta-chevron {
  fill: var(--pink);
  height: 2rem;
  width: 2rem;
}
.block-style-thirtyEight .row .solution-shape {
  display: block;
  height: 20rem;
  position: absolute;
  top: 0;
  right: -2rem;
  width: 20rem;
  z-index: -10;
  @media (max-width: 991px) {
    height: 10rem;
    width: 10rem;
  }
  @media (max-width: 1200px) {
    height: 15rem;
    width: 15rem;
  }
}
.block-style-thirtyEight .row .solution-shape {
  background-color: var(--darkblue);
}
.block-style-thirtyEight .row .solution-image-wrapper {
  padding: 4rem 0 0 0;
  position: relative;
  z-index: 10;
  height: 30rem;
  width: 30rem;
  @media (max-width: 991px) {
    height: 15rem;
    width: 15rem;
  }
  @media (max-width: 1200px) {
    height: 20rem;
    width: 20rem;
  }
}
.block-style-thirtyEight .row .solution-cross-white {
  position: absolute;
  top: 1rem;
  right: -1rem;
  height: 3rem;
  width: 3rem;
  @media (max-width: 991px) {
    top: 0.25rem;
    right: -1.75rem;
    height: 2rem;
    width: 2rem;
  }
  @media (max-width: 1200px) {
    top: 0.25rem;
    right: -1.75rem;
    height: 2.25rem;
    width: 2.25rem;
  }
}
.block-style-thirtyEight .row .solution-image-wrapper:before {
  display: block;
  font-size: 8rem;
  font-weight: 900;
  height: 8rem;
  left: 0;
  position: absolute;
  top: 1rem;
}

.block-style-thirtyEight .row .feature svg {
  height: 1rem;
  width: 1rem;
}
.block-style-thirtyEight:nth-child(1) .row .feature svg {
  fill: var(--pink);
}
.block-style-thirtyEight:nth-child(2) .row .feature svg {
  fill: var(--lightblue);
}
.block-style-thirtyEight:nth-child(3) .row .feature svg {
  fill: var(--orange);
}
.block-style-thirtyEight:nth-child(4) .row .feature svg {
  fill: var(--green);
}

.block-style-thirtyEight .row .step-cta {
  display: flex;
  align-items: center;
  padding: 0;
}
.block-style-thirtyEight:nth-child(1) .row .step-cta {
  color: var(--pink);
}
.block-style-thirtyEight:nth-child(2) .row .step-cta {
  color: var(--lightblue);
}
.block-style-thirtyEight:nth-child(3) .row .step-cta {
  color: var(--orange);
}
.block-style-thirtyEight:nth-child(4) .row .step-cta {
  color: var(--green);
}

.block-style-thirtyEight .row .step-cta svg {
  height: 2rem;
  width: 2rem;
}
.block-style-thirtyEight:nth-child(1) .row .step-cta svg {
  fill: var(--pink);
}
.block-style-thirtyEight:nth-child(2) .row .step-cta svg {
  fill: var(--lightblue);
}
.block-style-thirtyEight:nth-child(3) .row .step-cta svg {
  fill: var(--orange);
}
.block-style-thirtyEight:nth-child(4) .row .step-cta svg {
  fill: var(--green);
}
.process-steps-list {
  display: flex;
  justify-content: center;
  list-style: none;
  margin: 0 auto 2rem auto;
  padding: 0;
}
.process-steps-list li {
  color: #000;
  display: inline-block;
  font-weight: bold;
  margin: 0 1rem;
}
.process-steps-list li .steps-chevron {
  height: 2rem;
  width: 2rem;
}
.process-steps-list li:nth-child(1) .steps-chevron {
  fill: var(--pink);
}
.process-steps-list li:nth-child(2) .steps-chevron {
  fill: var(--lightblue);
}
.process-steps-list li:nth-child(3) .steps-chevron {
  fill: var(--orange);
}
.process-steps-list li:nth-child(4) .steps-chevron {
  fill: var(--green);
}
</style>
